<script setup>

import { ref, watch } from 'vue';

const props = defineProps({
    label: String,
    error: String,
    inputId: String,
    name: String,
    value: {
        type: [String, Number],
        default: null,
    },
    required: {
        type: Boolean,
        default: false,
    },
    hint: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
});

const model = defineModel();

const input = ref(null);

//if error is present, focus on the input
watch(() => props.error, (value) => {
    error.value = value;
}, {deep:true});

const error = ref(props.error);
</script>

<template>
    <div class="flex gap-x-1.5">
        <div class="flex h-6 items-center">
            <input ref="input" type="radio" v-model="model" :value="value" :id="inputId" :name="name" :required="required"
                :readonly="readonly" :disabled="disabled"
                class="text-tan border-gray-300 transition duration-200 ease-in-out focus:!ring-0"
                :class="error ? '!border-red-500' : ''" />
        </div>
        <div class="text-sm leading-6">
            <label :for="inputId" class="font-medium text-gray-900" v-text="label" />
            <p class="text-gray-500" v-if="hint" v-text="hint" />
        </div>
    </div>

    <p class="mt-2 text-sm text-red-600" v-if="error">
        {{ error }}
    </p>
</template>